<template>
	<div>
		<div class="mlogin" v-if="isMobile">
			<div class="item">
				<img class="logo" src="../assets/logo.png" width="20%" />
			</div>	
			<div class="item">
				<el-input placeholder="请输入手机号" v-model="mobile" @blur="VerifyInput()"  :class="msg==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-phone-outline"></i></el-input>
				<div class="msg">{{msg}}</div>
			</div>
			<div class="item">
				 <div class="line2-l">
				   <el-input maxlength="4" placeholder="请输入验证码" v-model="verifyCode" @input="VerifyInput1()" :class="msg1==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-chat-dot-round"></i></el-input>
				   <div class="msg">{{msg1}}</div>
				   </div>
				   <template v-if="isShowCode"><div class="line2-r"><a href="javascript:void(0)" @click="GetMobileToken()">获取验证码</a></div> </template>
				   <template v-else>  <div class="line2-r"><el-button type="info" plain disabled>重新获取({{seconds}}s)</el-button></div> </template>
			</div>
			<div class="item">
				 <p>未注册手机号验证后自动登录</p>
			</div>
			<div class="item">
				<template v-if="isSubmit"> <el-button type="primary" @click="login(1)">登 录</el-button> </template>
  			    <template v-else> <el-button type="info" plain disabled>登 录</el-button> </template>
			</div>
			<div class="item">
				<div class="protocol"><i @click="AgreeProtocol()" :class="isAgree?'icon3 icon3-checkbox-checked':'icon3 icon3-checkbox'" ></i>登录表示您同意<router-link to="/protocol">《注册协议》</router-link></div>
			    <div class="msg msg1">{{msg2}}</div>
			</div>
		</div>
		<div class="content" v-else>
           <div class="login">
               <h2>登录</h2>
               <div class="line1">
                  <!-- <i class="icon3 icon3-tel1"></i> <input maxlength="11" class="tel" placeholder="手机号" type="number" /> -->
				  <el-input placeholder="手机号" v-model="mobile" @blur="VerifyInput()"  :class="msg==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-phone-outline"></i></el-input>
				  <div class="msg">{{msg}}</div>
               </div>
               <div class="line2">
                   <!-- <div class="line2-l"><i class="icon3 icon3-yzm"></i> <input maxlength="4" class="yzm" placeholder="验证码" type="number" /></div>  -->
				   <div class="line2-l">
				   <el-input maxlength="4" placeholder="验证码" v-model="verifyCode" @input="VerifyInput1()" :class="msg1==''?'':'red'"><i slot="prefix" class="el-input__icon el-icon-chat-dot-round"></i></el-input>
				   <div class="msg">{{msg1}}</div>
				   </div>
				   <template v-if="isShowCode"><div class="line2-r"><a href="javascript:void(0)" @click="GetMobileToken()">获取验证码</a></div> </template>
				   <template v-else>  <div class="line2-r"><el-button type="info" plain disabled>重新获取({{seconds}}s)</el-button></div> </template>
				  
               </div>
               <div class="clear"></div>
               <p>未注册手机号验证后自动登录</p>
			   <template v-if="isSubmit"> <el-button type="primary" @click="login(1)">登 录</el-button> </template>
  			   <template v-else> <el-button type="info" plain disabled>登 录</el-button> </template>
				
			   
               <div class="protocol"><i @click="AgreeProtocol()" :class="isAgree?'icon3 icon3-checkbox-checked':'icon3 icon3-checkbox'" ></i>登录表示您同意<router-link to="/protocol">《注册协议》</router-link></div>
			   <div class="msg msg1">{{msg2}}</div>
           </div>
    </div>
	</div>
</template>
<style scoped>
.login {background:#fff; height:500px; margin-top:20px; margin-bottom:48px; padding:0 296px; border:solid 1px #e5e5e5;box-sizing: border-box; }
.login h2{ font-size:24px; margin:84px 0 60px; text-align:center; font-weight:normal; }
.login .line1{ width:366px; height:38px; line-height:38px;  margin-bottom:24px; }
.login .line1:hover{border-color:#1890ff;}
.login .line2-l{ width:234px; height:38px; line-height:38px;  float:left;}
.login .line2-l:hover{border-color:#1890ff;}
.login .line2-r{float:right;}
.login .line2-r button{width:122px; font-size:14px;}
.login .line2-r a{float:right; width:122px; border:solid 1px #DCDFE6;height:38px; line-height:38px; text-align:center;border-radius:3px; font-size:14px; color: #a1a1a1;}
.login .line2-r a:hover{border-color:#1890ff; color:#1890ff;}
.login .line2-r a:focus{border-color:#1890ff; color:#1890ff;}
.login input:hover{ border-color:#1890ff !important;}
.login p{color: #a4a4a4;font-size: 14px;height:38px; line-height:38px;margin-bottom:20px;margin-top:20px; }
.login button{ width:368px; font-size: 16px;}
.login .protocol{ font-size: 14px; margin-top:30px; cursor:pointer;}
.login .protocol i{ margin-left:80px; margin-right:5px;}
.login .protocol a{color:#1890ff;}
.login .msg{font-size:14px; color:#f5222d; line-height:24px;}
.login .msg1{text-align: center;}

.mlogin{ padding:0 5%; background: #fff;}
.mlogin .logo{ margin-top:1.2rem;}
.mlogin .line2-l{   float:left; width:65%; height:3rem; }

.mlogin .line2-r{float:right;width:30%;height:3.2rem;}
.mlogin .line2-r button{font-size:1rem; width:100%; padding:1.1rem 1rem; } 
.mlogin .line2-r a{float:right; width:100%; height:3.2rem; line-height: 3.2rem; border:solid 1px #DCDFE6; text-align:center;border-radius:3px; font-size:1.2rem; color: #a1a1a1; display: block;}
.mlogin p{color: #999;font-size:1.2rem;margin-top:3rem; text-align: left; }
.mlogin .protocol{ font-size:1.2rem; text-align: left; vertical-align: middle; }
.mlogin .protocol i{  margin-right:5px; margin-top:3px;}
.mlogin .msg{font-size:1.2rem; color:#f5222d; line-height:1.2rem;text-align: left;}
.mlogin .msg1{text-align: left;}

.mlogin .item{text-align: center; padding-bottom:1.2rem; color:#8c8c8c;  clear: both;}

.mtop{display: none !important;}

</style>
<script>
	
	export default {
		methods: {
			login(isVerify){
				//登录或者注册
				const self = this;
				if(self.mobile != "" && self.verifyCode != ""){
					self.isSubmit=false;
					self.http.ajaxGet("Login?Mobile="+self.mobile+"&VerifyCode="+self.verifyCode+"&IsVerify="+isVerify,function(res){
						if(res.ReturnCode == 1){
							//增加一个本地当前时间
							 res.Result[0].startTime=new Date();
							 self.common.SetlocalStorage(JSON.stringify(res.Result[0]),"UnLockUserData");
							 self.$store.dispatch('showActions',res.Result[0].NickName);
							 self.$message({message: res.Message, type: 'success'});   //提示成功消息
							 setTimeout(() => {
								self.$router.push({name: "home"});
							 }, 2000);
						}else{
							self.isSubmit=true;
							self.$message.error(res.Message);  //提示错误信息
						}	
					},function(err){
						self.isSubmit=true;
						self.$message.error(err);
					})
				}
			},
			GetMobileToken(){
				//获取验证码
				const self = this;
				var b=self.checkMobile(self.mobile);
				if(b){
					 self.countDown();
					self.http.ajaxGet("VerificateCode?UseType=12&Mobile="+self.mobile,function(res){
						if(res.ReturnCode == 1){
							 var message=res.Message==="OK"?"验证码已发送":res.Message;
							 self.$message({message: message, type: 'success'});   //提示成功消息
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
					})
				}
			},
			VerifyInput(){
				const self = this;
				self.isSubmit=false;
				if(self.mobile=="")
					self.msg="请输入手机号";
				else{
					var b=self.checkMobile(self.mobile);
					if(!b){
						self.msg="手机号不合法";
					}else{
						self.msg="";

						var b=self.checkCode(self.verifyCode);
						if(b && self.isAgree)
							self.isSubmit=true;
					}
				}
			},
			VerifyInput1(){
				const self = this;
				self.isSubmit=false;
				if(self.verifyCode=="")
					self.msg1="请输入验证码";
				else{
					var b=self.checkCode(self.verifyCode);
					if(!b){
						self.msg1="验证码为4位数字";
					}else{
						self.msg1="";

						var b=self.checkMobile(self.mobile);
						if(b && self.isAgree)
							self.isSubmit=true;
					}
				}
			},
			checkMobile (number) {
				var partten = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				return partten.test(number);
			},
			checkCode (number) {
				var partten = /^[0-9]{4}$/;
				return partten.test(number);
			},
			AgreeProtocol(){
				const self = this;
				if(self.isAgree){
					self.isAgree=false;
					self.msg2="请同意注册协议";
					self.isSubmit=false;
				}else{
					self.isAgree=true;
					self.msg2="";

					var b=self.checkMobile(self.mobile);
					var b1=self.checkCode(self.verifyCode);
					if(b && b1)
						self.isSubmit=true;
					else
						self.isSubmit=false;
				}
			},
			countDown(){
				const self = this;
				self.seconds=self.seconds-1;
				self.isShowCode=false;
				if(self.seconds==0)
				{
					self.seconds=60;
					self.isShowCode=true;
					return;
				}
				setTimeout(function(){self.countDown()},1000);
			}
		},
		data() {
			return {
				mobile:"",
				verifyCode : "",
				msg:"",
				msg1:"",
				msg2:"",
				isSubmit:false,
				isShowCode:true,
				isAgree:true,
				seconds:60
			}
		},
		mounted: function () {
			this.common.ClearlocalStorage("UnLockUserData");
			this.$store.dispatch('hideActions');

			var path=location.href;
			var index=path.indexOf("mobile");
			if(index!=-1){
				var mobile=path.substring(index+7);
				this.mobile=mobile;
				this.verifyCode=1234;
				this.login(0);
			}
		},
		computed:{
			isMobile(){
				return this.common.isMobile();
			}
  		}
	}
</script>



// WEBPACK FOOTER //
// src/views/login.vue